"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshToken = void 0;
var tslib_1 = require("tslib");
var js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
var requests_1 = require("../../http/requests");
var utils_1 = require("../../../utils");
var Settings_1 = tslib_1.__importDefault(require("../../http/Settings"));
var read_1 = require("../../commons/read");
function refreshToken() {
    var _a = Settings_1.default.getInstance(), domain = _a.domain, envAcronym = _a.envAcronym, urlAuth = _a.urlAuth;
    var rt = JSON.parse(js_cookie_1.default.get(envAcronym + "mp_rt"));
    var body = read_1.clientSettings(rt);
    var params = utils_1.paramSerializer(body).replace('?', '');
    return requests_1.request
        .post(urlAuth + "/connect/token", params)
        .then(function (data) {
        var res = data;
        var path = '/';
        var today = new Date();
        var expires = new Date(today.getTime() + (res.expires_in * 1000));
        var expiresTk = new Date(today.getTime() + (res.expires_in * 850));
        var refreshToken = Object.assign(tslib_1.__assign(tslib_1.__assign({}, rt), { refresh_token: res.refresh_token }));
        js_cookie_1.default.set(envAcronym + "mp_tk", res.access_token, { expires: expires, path: path, domain: domain });
        js_cookie_1.default.set(envAcronym + "mp_rt", JSON.stringify(refreshToken), { expires: expires, path: path, domain: domain });
        js_cookie_1.default.set(envAcronym + "mp_et", expiresTk, { expires: expiresTk, path: path, domain: domain });
        return res;
    })
        .catch(function (err) {
        throw err;
    });
}
exports.refreshToken = refreshToken;
//# sourceMappingURL=create.js.map